import React from "react";
import Axios from 'axios'
import MasterTemplate from "./MasterTemplate";
import Cartela from '../_Components/Cartela'
import moment from 'moment';
import { Link } from 'react-router-dom';
import API from '../Utils/api'

export class GanhadoresMaster extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem("user")),
            cartelaSelecionada: null,
            tipoSelecionado: '',
            gabaritos: [],
            clientes: [],
            clienteSelecionado: null,
            gerentes: [],
            filteredList: []
        };

        if(localStorage.getItem('authAdmin') != 'authorized'){
            window.location.href="/master-ganhadores-geral"
        }
        this.selecionarCartela = this.selecionarCartela.bind(this)
        this.listarGanhadores();
        this.listarGerentes();
    }

    formatDate(data) {
        return moment(data).add(0, 'days').format('DD-MM-YYYY')
    }

    selecionarCartela(e) {
        const gabarito = JSON.parse(e.target.accessKey);
        this.state.tipoSelecionado = gabarito.tipo;
        this.setState({ ...this.state, cartelaSelecionada: gabarito.cartelaSorteada, tipoSelecionado: gabarito.tipo })
    }

    listarGanhadores = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("gabaritos/gabaritos-ativos");
            this.setState({ gabaritos: response.data, filteredList: response.data });

        } catch (err) {
            console.log(err);
        }
    };

    listarGerentes = async e => {
        try {
            const response = await API.post('/api/usuarios/listar-todos-gerentes')
            this.setState({gerentes: response.data.sort(this.compararNome)})
        } catch (err) {
            console.log(err)
        }
    }

    async putGerenteInGabarito(_id, gerenteId) {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.post("gabaritos/put-gerente-in-gabarito", { _id: _id, gerenteId: gerenteId });
        } catch (err) {
            console.log(err);
        }
    };

    async getClientesPorCambista(item) {
        this.setState({ cartelaSelecionada: item })
        try {
            const response = await API.post("/api/usuarios/listar-por-tutor", {
                tutorId: item.cambistaId._id
            });
            this.setState({ clientes: response.data.sort(this.compararNome) });
        } catch (err) {
            console.log(err);
        }
    };

    compararNome(a, b) {
        if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
            return 1;
        }
        if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
            return -1;
        }
        return 0
    }

    setCliente(e) {
        this.state.clienteSelecionado = JSON.parse(e.target.value);
        this.setState({ clienteSelecionado: JSON.parse(e.target.value) })
    }

    async salvarPedidoEditado() {
        this.state.cartelaSelecionada.ganhadorId = this.state.clienteSelecionado._id;
        this.state.cartelaSelecionada.cambistaId = this.state.clienteSelecionado.tutorId;
        if (this.state.clienteSelecionado) {
            try {
                const response = await API.post("/api/gabaritos/update-gabarito", {
                    ...this.state.cartelaSelecionada
                });
                alert("Salvo com sucesso!")
                window.location.reload()
            } catch (err) {
                console.log(err);
            }
        }
    }


    filterByGerente(e){
        if(e.target.value != ""){
            var filtered = this.state.gabaritos.filter(item => item.gerenteId && item.gerenteId._id == e.target.value);

            this.setState({filteredList : filtered});
        }
        else{
            this.setState({filteredList : this.state.gabaritos});
        }
    }

    render() {
        return (
            <MasterTemplate label={'Ganhadores'}>

                <div class="modal fade" id="exampleModalCenter2" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '50vw' }} role="document">
                        <div class="modal-content "  >
                            <div class="modal-header">
                                <h4 class="modal-title font-weight-bolder" id="exampleModalLongTitle">Editar o cliente do pedido</h4>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <h4>Procure o cliente correto</h4>
                                <select onChange={this.setCliente.bind(this)} style={{ zIndex: '3000' }} class="ml-1 custom-select">
                                    <option value={JSON.stringify(null)} selected>Selecione um cliente</option>
                                    {this.state.clientes.length > 0 ? this.state.clientes.map(cliente => {
                                        return <option value={JSON.stringify(cliente)}>{cliente.nome} - {cliente.telefone}</option>
                                    }) : ""}
                                </select>
                            </div>
                            <div class="modal-footer" style={{ justifyContent: 'flex-end' }}>
                                <button className="btn btn-fill btn-success" onClick={this.salvarPedidoEditado.bind(this)}>Salvar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content" style={{ marginTop: '-5em' }}>
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Detalhes da cartela</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            {this.state.cartelaSelecionada ?

                                <div class="modal-body justify-content-center">
                                    <Cartela class="ml-3" conferir={this.state.tipoSelecionado} cartela={this.state.cartelaSelecionada}></Cartela>
                                </div>
                                : ""}

                            <div class="modal-footer">
                                <button data-dismiss="modal" aria-label="Close" data-toggle="modal" data-target="#staticBackdrop" type="button" class="btn-fill btn btn-primary">Voltar</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <select onChange={this.filterByGerente.bind(this)} className="form-select" aria-label="Default select example">
                        <option value="" selected>Selecione algum gerente</option>
                        {this.state.gerentes.map(gerente => {
                            return <option value={gerente._id}>{gerente.nome}</option>
                        })}
                        
                    </select>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card strpied-tabled-with-hover">
                                <div className="card-header ">
                                    <h4 className="card-title">
                                        Todos os ganhadores da semana
                                    </h4>
                                    <p className="card-category">
                                        Informações dos premios da rodada.
                                    </p>
                                </div>
                                <div className="card-body table-full-width table-responsive">
                                    <table className="table table-hover table-striped">
                                        <thead>
                                            <tr>
                                                <th>Tipo de batida</th>
                                                <th>Cartela</th>
                                                <th>Ganhador</th>
                                                <th>Telefone</th>
                                                <th>Endereço</th>
                                                <th>Vendedor</th>
                                                <th>Gerente</th>
                                                <th>Preview</th>
                                                <th>Editar</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.filteredList?.map(item => {
                                                    return (
                                                        <tr>
                                                            <td>{item.tipo}</td>
                                                            <td>{item.cartelaSorteada.codigo}</td>
                                                            <td>{item.ganhadorId ? item.ganhadorId.nome : "Desconhecido"}</td>
                                                            <td>{item.ganhadorId ? item.ganhadorId.telefone : "Desconhecido"}</td>
                                                            <td>{item.ganhadorId?.endereco} - {item.ganhadorId?.bairro} - {item.ganhadorId?.cidade} - {item.ganhadorId?.estado}</td>
                                                            <td>{item.cambistaId ? item.cambistaId.nome : "Desconhecido"}</td>
                                                            <td>{item.gerenteId ? item.gerenteId.nome : "Desconhecido"}</td>
                                                            <td><button onClick={this.selecionarCartela} accessKey={JSON.stringify(item)} class="btn-fill btn btn-success" data-toggle="modal" data-dismiss="modal" data-target="#exampleModal" >Preview</button></td>
                                                            <td><button className="btn mt-4" data-toggle="modal" data-target="#exampleModalCenter2" onClick={() => this.getClientesPorCambista(item)} >Editar</button></td>
                                                        </tr>
                                                    );
                                                })}
                                                
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MasterTemplate>
        );
    }
}

export default GanhadoresMaster;
